import Component from 'inferno-component';
import AddToFlashcardDeckIcon from '../assets/images/add-to-deck-horizontal-icon';

class DefinitionPreviewRow extends Component {
  render() {
    const { word, setModalWord } = this.props;
    const wordLink = `/definition/${word.id}`;
    return (
      <li className="definition-preview-row__item">
        <a className="definition__word" href={wordLink}>
          {word.word}{' '}
          {word.pronunciation ? (
            <img
              className="definition-preview-row__media-icon"
              src="/pronunciation-icon.svg"
              alt="Definition pronunciation icon"
            />
            ) : null}
            {word.definitions && word.definitions.filter(definition => definition.media && definition.media.audio)
              .length ? (
              <img
                className="definition-preview-row__media-icon"
                src="/example-sound-icon.svg"
                alt="Definition audio icon"
              />
            ) : null}
            {word.definitions && word.definitions.filter(
              definition => definition.media && definition.media.images && definition.media.images
            ).length ? (
              <img
                className="definition-preview-row__media-icon"
                src="/image-icon.svg"
                alt="Definition image icon"
              />
            ) : null}
        </a>
        <button
          className="button--invisible definition__add-to-deck"
          onClick={() => setModalWord(word)}
        >
          <AddToFlashcardDeckIcon />
        </button>
        <div className="definition__word-details">
          <span className="definition__word-class">
            {word.definitions[0].ps}{' '}
          </span>
          <a className="definition__text" href={wordLink}>
            {word.definitions[0].dtxt}
          </a>
          {word.definitions.length > 1 && (
            <a className="definition__additional-link" href={wordLink}>
              {word.definitions.length - 1} additional definitions &#187;
            </a>
          )}
        </div>
      </li>
    );
  }
}

export default DefinitionPreviewRow;



// WEBPACK FOOTER //
// ./src/components/DefinitionPreviewRow.js